// Excel settings management utilities

const STORAGE_KEY = "excel_settings";

// Default Excel configuration
const DEFAULT_EXCEL_SETTINGS = {
  headerRow: 3, // Default row containing column headers (Excel row 3)
  startRow: 4, // Default starting row for data
  columnHeaders: {
    A: "Item No.",
    B: "Unit No.",
    C: "VLE Class Name",
    D: "Unit Name",
    E: "Lecturer",
    F: "Day/Time",
    G: "EW/Time",
    H: "Group",
    I: "Cohort",
    J: "Room Allocated",
    K: "Students Coming",
    L: "Student Number",
  },
  columnWidths: {
    A: 10, // Item No
    B: 18, // Unit No
    C: 45, // VLE Class Name
    D: 55, // Unit Name
    E: 20, // Lecturer
    F: 15, // Day/Time
    G: 15, // EW/Time
    H: 10, // Group
    I: 15, // Cohort
    J: 20, // Room Allocated
    K: 20, // Students Coming
    L: 20, // Student Number
  },
};

/**
 * Load Excel settings from localStorage or return defaults
 */
export const loadExcelSettings = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const settings = JSON.parse(stored);
      return {
        ...DEFAULT_EXCEL_SETTINGS,
        ...settings,
      };
    }
    return DEFAULT_EXCEL_SETTINGS;
  } catch (error) {
    console.error("Error loading Excel settings:", error);
    return DEFAULT_EXCEL_SETTINGS;
  }
};

/**
 * Save Excel settings to localStorage
 */
export const saveExcelSettings = (settings) => {
  try {
    const validatedSettings = {
      ...DEFAULT_EXCEL_SETTINGS,
      ...settings,
      startRow: parseInt(settings.startRow) || 4,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(validatedSettings));
    return validatedSettings;
  } catch (error) {
    console.error("Error saving Excel settings:", error);
    throw error;
  }
};
